import { Box, Button, TextField, ThemeProvider, createTheme } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import AuthGuard from "../../components/AuthGuard";
import { useCookies } from "react-cookie";


let theme = createTheme({
  palette: {
    primary: {
      main: '#0052cc',
    },
    secondary: {
      main: '#1A8D90',
    },
  },
});

const Form = ({callBackAfterSubmit}) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [cookie,setCookie] = useCookies(['token'])

  const handleFormSubmit = (values) => {
    fetch(process.env.REACT_APP_BACKEND_URL+"/role/add",{method:"POST",headers:{
      Authorization:"Bearer "+cookie['token'],
      'Content-Type': 'application/json' 
    },body:JSON.stringify(values),}).catch(()=>{
        setCookie("token",null)
        return 
    })
    callBackAfterSubmit()
  };

  return (
    <AuthGuard>
    <Box m="450px" mt={"5rem"} sx={{background:"white",width: "90%",
          maxWidth: "800px",boxSizing:"border-box",px:"1rem",zIndex:999}}>
    <Header title="CREATE ROLE" subtitle="Create a New Role" />
    <ThemeProvider theme={theme}>
        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                  pt:"3rem"
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.name}
                  name="name"
                  error={!!touched.firstName && !!errors.firstName}
                  helperText={touched.firstName && errors.firstName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Description"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.description}
                  name="description"
                  error={!!touched.lastName && !!errors.lastName}
                  helperText={touched.lastName && errors.lastName}
                  sx={{ gridColumn: "span 2" }}
                />
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button type="submit" color="secondary" variant="contained">
                  Create New Role
                </Button>
              </Box>
            </form>
          )}
        </Formik>
</ThemeProvider>
          </Box>
    </AuthGuard>
  );
};


const checkoutSchema = yup.object().shape({
  name: yup.string().required("required"),
  description: yup.string().required("required"),
});
const initialValues = {
  name:"",
  description:""
};

export default Form;
